import { colorTokens } from '@/apps/legacy/shared/styles/colorTokens'

// スクロールバーの共通スタイル定義
export const customScrollbarStyles = {
  '&::-webkit-scrollbar': {
    width: '8px',
  },
  '&::-webkit-scrollbar-track': {
    backgroundColor: colorTokens.grey[100],
    borderRadius: '4px',
  },
  '&::-webkit-scrollbar-thumb': {
    backgroundColor: colorTokens.border.medium,
    borderRadius: '4px',
    '&:hover': {
      backgroundColor: colorTokens.grey[400],
    },
  },
}
